import React from "react";

const MyButton = ({ text, link, icon }) => {
    return (
        <a
            download
            className="relative inline-block group focus:outline-none focus:ring"
            href={link}
        >
            <span className="absolute inset-0 transition-transform translate-x-1.5 translate-y-1.5 bg-blue-300 dark:bg-lime-300 dark:text-zinc-900 group-hover:translate-y-0 group-hover:translate-x-0"></span>

            <span className="relative inline-block px-8 py-3 text-sm font-extrabold tracking-widest uppercase border-2 dark:border-lime-300 border-current group-active:text-opacity-75 dark:text-zinc-900 btn-color font-mono">
                {text}
                {icon}
            </span>
        </a>
    );
};

export default MyButton;